module.exports = __webpack_public_path__ + "img/page-marker.d53acff2.svg";